import api from "api";

export function getOnePostPurchaseFeedback(case_id) {
    return api.get(`post_purchase_feedback/${case_id}`);
}

export function getAllPostPurchaseFeedback() {
    return api.get(`post_purchase_feedback`);
}

export function createPostPurchaseFeedback(case_id, feedback) {
    return api.post(`post_purchase_feedback/${case_id}`, feedback);
}

export function updatePostPurchaseFeedback(case_id, feedback) {
    return api.put(`post_purchase_feedback/${case_id}`, feedback);
}
